import React from 'react'
import { FormattedMessage } from 'react-intl'
import Link from 'redux-first-router-link'
import { goToPost } from 'actions/posts'
import Dialog from 'components/Dialog'
import SharingButtons from 'components/SharingButtons'
import styles from './SharePostDialog.css'

export const SharePostDialogContent = ({ url, post, author }) => (
  <div className={styles.share_post_dialog}>
    <span className={styles.message}>
      <FormattedMessage id="compose.share.share_article" />
    </span>
    <SharingButtons url={url} title={post.title} tags={post.tags} />
    <Link
      className={styles.url}
      to={goToPost({
        _id: post._id,
        group: post.group,
        name: post.name,
        username: author && author.username,
        meta: {
          location: {
            kind: 'redirect'
          }
        }
      })}
    >
      {url}
    </Link>
  </div>
)

const SharePostDialog = ({ onClose, url, post, author, hidden }) => {
  if(hidden) {
    return null
  }

  return (
    <Dialog title="post.share" onClose={onClose}>
      <SharePostDialogContent
        url={url}
        post={post}
        author={author || post.author}
      />
    </Dialog>
  )
}

export default SharePostDialog
